import { forwardRef } from 'react';

import Icon from '../icon';

import SortDescSvgIcon from './sort-desc.svg?react';

/* This file is autogenerated, see readme.md for instructions */
import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

/**
 * @deprecated This icon has been removed from the @bloomreach/banana-theme package.
 * Please don't use it anymore. It will be removed in the next major version.
 */
const SortDescIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SortDescSvgIcon />
    </Icon>
  );
});

SortDescIcon.displayName = 'SortDescIcon';

export default SortDescIcon;
